module.exports = __webpack_public_path__ + "odinstatic/v13.0.1/media/error.65d70633.svg";